const XFactorAlt = () => {
  return (
    <section className="py-32 px-4 bg-primary text-primary-foreground">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left - Big X */}
          <div className="relative">
            <div className="text-[20rem] md:text-[25rem] font-black leading-none opacity-5 absolute -top-20 -left-10 text-primary-foreground">
              X
            </div>
            <div className="relative z-10 space-y-6">
              <h2 className="text-5xl md:text-7xl font-black leading-tight text-primary-foreground">
                THE<br />
                <span className="text-accent">
                  X-FACTOR
                </span>
              </h2>
              <p className="text-2xl font-bold text-primary-foreground border-l-4 border-accent pl-6">
                Execution × Ecosystem × Experience
              </p>
            </div>
          </div>

          <div className="space-y-8">
            <div className="space-y-4 border-l-4 border-accent pl-6 py-4 hover:border-primary-foreground transition-colors">
              <h3 className="text-2xl font-black tracking-wide text-primary-foreground">FOR FOUNDERS</h3>
              <p className="text-lg text-primary-foreground/90 leading-relaxed">
                Investment plus GTM capability. We provide capital and open doors to hyperscaler ecosystems and enterprise networks.
              </p>
            </div>

            <div className="space-y-4 border-l-4 border-accent pl-6 py-4 hover:border-primary-foreground transition-colors">
              <h3 className="text-2xl font-black tracking-wide text-primary-foreground">FOR PARTNERS</h3>
              <p className="text-lg text-primary-foreground/90 leading-relaxed">
                Strategic collaboration. Join our ecosystem to co-sell, integrate, and unlock new revenue streams together.
              </p>
            </div>

            <div className="space-y-4 border-l-4 border-accent pl-6 py-4 hover:border-primary-foreground transition-colors">
              <h3 className="text-2xl font-black tracking-wide text-primary-foreground">FOR CUSTOMERS</h3>
              <p className="text-lg text-primary-foreground/90 leading-relaxed">
                Access to innovation. Discover cutting-edge products and services from our portfolio companies, integrated with your existing platforms.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default XFactorAlt;
